import { render, staticRenderFns } from "./BottomRightTable4.vue?vue&type=template&id=218de656&"
import script from "./BottomRightTable4.vue?vue&type=script&lang=js&"
export * from "./BottomRightTable4.vue?vue&type=script&lang=js&"
import style0 from "./BottomRightTable4.vue?vue&type=style&index=0&id=218de656&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports